import {useEffect, useRef} from "react";

const FormAutosave = ({formik, autoSubmitMilliseconds}) => {
    const isDirty = useRef(false);
    const isFirst = useRef(true);
    const lastUpdated = useRef(0);

    useEffect(() => {
        const interval = setInterval(() => {
            if(!isFirst.current && isDirty.current && (lastUpdated.current + autoSubmitMilliseconds) < Date.now())
            {
                isDirty.current = false;
                formik.handleSubmit();
            }

            if(isFirst.current) {
                isFirst.current = false;
                isDirty.current = false;
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [formik, autoSubmitMilliseconds])


    useEffect(() => {
        isDirty.current = true;
        lastUpdated.current = Date.now();
    }, [formik.values]);

    return (<></>);
}

export default FormAutosave;
